module.exports = __webpack_public_path__ + "static/media/20220912_175305.30447135.jpg";